// @TODO as a style rule for enum type each field should start from capital letter

export enum TipType {
  adminFormManagement = 'adminFormManagement',
  dragSelectedForm = 'dragSelectedForm',
  adminUpload = 'adminUpload',
  clientsManagement = 'clientsManagement',
  adminContentManagement = 'adminContentManagement',
  dragSelectedContent = 'dragSelectedContent',
  contentShowUp = 'contentShowUp',
  adminBeforeAfterGalleries = 'adminBeforeAfterGalleries',
  adminEducationManagement = 'adminEducationManagement',
  adminPhotos = 'adminPhotos',
  notesSnippets = 'notesSnippets',
  notesShortcuts = 'notesShortcuts',
  facesheetClient = 'facesheetClient',
  clientTagsGlobal = 'clientTagsGlobal',
  clientTagsAccount = 'clientTagsAccount',
  facesheetInterest = 'facesheetInterest',
  treatmentProductDetails = 'treatmentProductDetails',
  adminLocations = 'adminLocations',
  adminTeam = 'adminTeam',
  adminTeamProfile = 'adminTeamProfile',
  adminTeamRole = 'adminTeamRole',
  adminTeamLocations = 'adminTeamLocations',
  notes = 'notes',
  profile = 'profile',
  notification = 'notification',
  userSecurity = 'userSecurity',
  galleries = 'galleries',
  capture = 'capture',
  dragSelectedContentTemplate = 'dragSelectedContentTemplate',
  adminTVManagement = 'adminTVManagement',
}
